// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list[data-v-39c08c87]{margin:10px 0}.list[data-v-39c08c87]:not(:last-of-type){border-bottom:1px solid #000;padding-bottom:7px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
